export const checkEmptyProperties = (obj) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] === '') {
        return true;
      }
    }
    return false;
  }